import SvgIcon, { SvgIconProps } from "./SvgIcon";

const DocumentIcon: React.FC<SvgIconProps> = ({
  variant = "contained",
  ...props
}) => {
  return (
    <SvgIcon {...props}>
      {variant == "contained" ? (
        <>
          <path d="M9.17157 3C9.70201 3 10.2107 3.21071 10.5858 3.58578L12.7071 5.70711C12.8946 5.89464 13.149 6 13.4142 6H21C22.1046 6 23 6.89543 23 8V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5C1 3.89543 1.89543 3 3 3H9.17157Z" />
          <path
            d="M7 14L17 14"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      ) : (
        <path d="M9.17188 3C9.7022 3.00008 10.2109 3.21094 10.5859 3.58594L12.707 5.70703C12.8945 5.89453 13.1489 5.99996 13.4141 6H21C22.1046 6 23 6.89543 23 8V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5C1 3.89543 1.89543 3 3 3H9.17188ZM3 19H21V8H13.4141C12.6848 7.99996 11.9827 7.73442 11.4375 7.25684L11.293 7.12109L9.17188 5H3V19ZM17 13C17.5523 13 18 13.4477 18 14C18 14.5523 17.5523 15 17 15H7C6.44772 15 6 14.5523 6 14C6 13.4477 6.44772 13 7 13H17Z" />
      )}
    </SvgIcon>
  );
};

export default DocumentIcon;
